var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopImgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_57321)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 40,
    rx: 203,
    ry: 125,
    fill: "url(#paint0_linear_2053_57321)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint1_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint2_radial_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint3_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint4_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint5_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.858 124.744L204.375 120.973L166.569 189.955L174.795 190.864L210.858 124.744Z",
    fill: "url(#paint6_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint7_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint8_radial_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint9_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint10_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint11_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint12_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 124.744L186.09 120.973L149.625 188.104L156.513 190.864L192.579 124.744Z",
    fill: "url(#paint13_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.234 120.504L174.717 124.275L151.089 167.598L149.688 154.344L168.234 120.504Z",
    fill: "url(#paint14_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.234 120.504L174.717 124.275L151.089 167.598L149.688 154.344L168.234 120.504Z",
    fill: "url(#paint15_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.234 120.504L174.717 124.275L151.089 167.598L149.688 154.344L168.234 120.504Z",
    fill: "url(#paint16_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.234 120.504L174.717 124.275L151.089 167.598L149.688 154.344L168.234 120.504Z",
    fill: "url(#paint17_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.298 134.441L182.859 193.634H191.559L213.408 153.575L215.298 134.441Z",
    fill: "url(#paint18_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.298 134.441L182.859 193.634H191.559L213.408 153.575L215.298 134.441Z",
    fill: "url(#paint19_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.298 134.441L182.859 193.634H191.559L213.408 153.575L215.298 134.441Z",
    fill: "url(#paint20_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.298 134.441L182.859 193.634H191.559L213.408 153.575L215.298 134.441Z",
    fill: "url(#paint21_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.062 127L157.548 123.229L196.077 193.543L187.125 193.12L151.062 127Z",
    fill: "url(#paint22_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.062 127L157.548 123.229L196.077 193.543L187.125 193.12L151.062 127Z",
    fill: "url(#paint23_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.062 127L157.548 123.229L196.077 193.543L187.125 193.12L151.062 127Z",
    fill: "url(#paint24_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.977 122.613L173.46 118.842L211.266 187.821L203.04 188.73L166.977 122.613Z",
    fill: "url(#paint25_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.977 122.613L173.46 118.842L211.266 187.821L203.04 188.73L166.977 122.613Z",
    fill: "url(#paint26_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.977 122.613L173.46 118.842L211.266 187.821L203.04 188.73L166.977 122.613Z",
    fill: "url(#paint27_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.3 153.567L171.786 198.462L180.738 198.882L147.297 137.865L147.3 153.567Z",
    fill: "url(#paint28_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.3 153.567L171.786 198.462L180.209 198.354L147.297 137.865L147.3 153.567Z",
    fill: "url(#paint29_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.419 126.988V125.572H195.249L210.735 153.832L208.389 165.433L187.419 126.988Z",
    fill: "url(#paint30_linear_2053_57321)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.419 126.988V125.572H195.249L210.735 153.832L208.389 165.433L187.419 126.988Z",
    fill: "url(#paint31_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.419 126.988V125.572H195.249L210.735 153.832L208.389 165.433L187.419 126.988Z",
    fill: "url(#paint32_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.363 126.932L209.988 126.812L201.27 195.204L210.645 195.324L219.363 126.932Z",
    fill: "url(#paint33_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.363 126.932L209.988 126.812L201.27 195.204L210.645 195.324L219.363 126.932Z",
    fill: "url(#paint34_radial_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.363 126.932L209.988 126.812L201.27 195.204L210.645 195.324L219.363 126.932Z",
    fill: "url(#paint35_radial_2053_57321)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.589 123.838L149.964 123.721L158.685 192.112L149.31 192.229L140.589 123.838Z",
    fill: "url(#paint36_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.589 123.838L149.964 123.721L158.685 192.112L149.31 192.229L140.589 123.838Z",
    fill: "url(#paint37_radial_2053_57321)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.774 116.854H143.976C140.754 116.854 138.141 119.466 138.141 122.689V122.692C138.141 125.914 140.754 128.527 143.976 128.527H216.774C219.997 128.527 222.609 125.914 222.609 122.692V122.689C222.609 119.466 219.997 116.854 216.774 116.854Z",
    fill: "#E75E3C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ii_2053_57321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.056 186.945H152.694C149.471 186.945 146.859 189.558 146.859 192.78V192.783C146.859 196.006 149.471 198.618 152.694 198.618H208.056C211.278 198.618 213.891 196.006 213.891 192.783V192.78C213.891 189.558 211.278 186.945 208.056 186.945Z",
    fill: "#E75E3C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.056 187.154H152.694C149.471 187.154 146.859 189.767 146.859 192.989V192.992C146.859 196.215 149.471 198.827 152.694 198.827H208.056C211.278 198.827 213.891 196.215 213.891 192.992V192.989C213.891 189.767 211.278 187.154 208.056 187.154Z",
    fill: "url(#paint38_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 81.0073C208 28.6562 108 54.2609 108 54.2609C108 54.2609 190.5 51.6562 223.263 103.009L247.423 81.0073Z",
    fill: "url(#paint39_linear_2053_57321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.421 81.4552L230.738 91.0233L211.443 90.0989L230.047 69.8355C230.047 69.8355 236.052 72.1682 239.46 74.0319C242.868 75.8956 247.421 81.4552 247.421 81.4552Z",
    fill: "#FBD7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.379 100.806L214.961 88.882L229.88 69.9339L239.021 80.2791L239.125 89.458L230.524 92.6583L225.379 100.806Z",
    fill: "#D1B1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.867 100.623L232.472 85.5355L229.938 69.9419C229.938 69.9419 224.815 72.8376 218.848 78.5696C212.88 84.3017 211.658 90.1989 211.658 90.1989C211.658 90.1989 214.61 94.2789 217.68 96.56C220.749 98.8411 225.867 100.623 225.867 100.623Z",
    fill: "#E8C2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.066 84.8162L233.33 84.8162L249.574 95.2001L223.263 103.508C223.263 103.508 219.237 98.5056 217.223 95.1988C215.21 91.8921 214.066 84.8162 214.066 84.8162Z",
    fill: "#FBD7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.893 79.0065L245.913 94.5078L223.456 103.507L220.747 90.0078L225.276 82.007L234.337 83.5078L242.893 79.0065Z",
    fill: "#D1B1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.378 78.9234L229.064 88.7087L223.41 103.472C223.41 103.472 229.304 103.508 237.357 101.508C245.41 99.5083 249.437 95.0083 249.437 95.0083C249.437 95.0083 248.934 90.0083 247.424 86.5083C245.914 83.0083 242.378 78.9234 242.378 78.9234Z",
    fill: "#E8C2B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2053_57321",
    x: 166.469,
    y: 120.873,
    width: 44.4891,
    height: 70.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2053_57321",
    x: 149.525,
    y: 120.873,
    width: 43.1541,
    height: 70.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_2053_57321",
    x: 149.588,
    y: 120.404,
    width: 25.2288,
    height: 47.2938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_2053_57321",
    x: 182.759,
    y: 134.341,
    width: 32.639,
    height: 59.3934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_2053_57321",
    x: 150.962,
    y: 123.129,
    width: 45.2151,
    height: 70.5145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_2053_57321",
    x: 166.877,
    y: 118.742,
    width: 44.4891,
    height: 70.0887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_2053_57321",
    x: 147.197,
    y: 137.765,
    width: 33.6409,
    height: 61.2176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_2053_57321",
    x: 187.319,
    y: 125.472,
    width: 23.5159,
    height: 40.0613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.367694 0 0 0 0 0.233576 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.351373 0 0 0 0 0.219608 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_2053_57321",
    x: 201.27,
    y: 126.688,
    width: 18.2178,
    height: 68.6367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.125,
    dy: -0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_2053_57321",
    x: 140.589,
    y: 123.596,
    width: 18.2212,
    height: 68.6328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.125,
    dy: -0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_2053_57321",
    x: 138.141,
    y: 116.354,
    width: 84.6678,
    height: 12.1738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_2053_57321",
    x: 146.859,
    y: 186.445,
    width: 67.2322,
    height: 12.1738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2053_57321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.215686 0 0 0 0 0.0509804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2053_57321",
    result: "effect2_innerShadow_2053_57321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2053_57321",
    x1: 180,
    y1: 7.69068,
    x2: 180,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2053_57321",
    x1: 207.75,
    y1: 122.827,
    x2: 169.896,
    y2: 191.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.093 155.761) rotate(33.6901) scale(8.11249 55.6992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2053_57321",
    x1: 205.407,
    y1: 124.447,
    x2: 202.875,
    y2: 135.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A0B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.092 144.039) rotate(154.564) scale(4.25634 26.1527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.823 159.044) rotate(151.238) scale(6.42969 39.5067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.438 174.51) rotate(152.488) scale(5.07378 31.1754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2053_57321",
    x1: 189.471,
    y1: 122.827,
    x2: 152.706,
    y2: 189.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.971 146.011) rotate(122.412) scale(34.9809 12.6105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2053_57321",
    x1: 187.161,
    y1: 124.384,
    x2: 184.614,
    y2: 135.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.135 143.452) rotate(155.362) scale(4.17609 25.8874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.11 158.007) rotate(152.002) scale(6.29841 39.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.97 173.02) rotate(153.266) scale(4.9731 30.8901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF370D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2053_57321",
    x1: 156,
    y1: 183.979,
    x2: 163.875,
    y2: 179.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2053_57321",
    x1: 170.625,
    y1: 128.667,
    x2: 155.157,
    y2: 153.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.338 136.422) rotate(-27.7182) scale(3.42515 10.1281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2053_57321",
    x1: 155.064,
    y1: 153.978,
    x2: 157.689,
    y2: 152.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2053_57321",
    x1: 171.939,
    y1: 127.167,
    x2: 167.157,
    y2: 132.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2053_57321",
    x1: 208.407,
    y1: 160.727,
    x2: 193.968,
    y2: 187.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2053_57321",
    x1: 207.843,
    y1: 167.009,
    x2: 202.593,
    y2: 165.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2053_57321",
    x1: 208.218,
    y1: 157.82,
    x2: 204.093,
    y2: 160.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#DF370D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75E3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.856 176.989) rotate(151.699) scale(3.4605 18.9026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2053_57321",
    x1: 155.814,
    y1: 132.229,
    x2: 192.753,
    y2: 195.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2053_57321",
    x1: 154.17,
    y1: 125.083,
    x2: 157.947,
    y2: 134.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2053_57321",
    x1: 193.215,
    y1: 189.763,
    x2: 188.826,
    y2: 183.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2053_57321",
    x1: 170.085,
    y1: 120.693,
    x2: 207.939,
    y2: 189.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2053_57321",
    x1: 204.033,
    y1: 179.982,
    x2: 200.043,
    y2: 179.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2053_57321",
    x1: 173.343,
    y1: 124.917,
    x2: 173.343,
    y2: 131.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2053_57321",
    x1: 149.016,
    y1: 149.952,
    x2: 161.301,
    y2: 181.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2053_57321",
    x1: 153.189,
    y1: 160.542,
    x2: 159,
    y2: 160.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2053_57321",
    x1: 194.814,
    y1: 128.761,
    x2: 208.362,
    y2: 152.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2053_57321",
    x1: 197.775,
    y1: 127.225,
    x2: 197.472,
    y2: 131.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2053_57321",
    x1: 207.375,
    y1: 159.793,
    x2: 205.407,
    y2: 159.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2053_57321",
    x1: 205.689,
    y1: 161.066,
    x2: 215.25,
    y2: 162.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF370D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.36 128.477) rotate(97.849) scale(66.2457 5.26495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.407 125.853) rotate(155.072) scale(17.7945 4.01129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2053_57321",
    x1: 147.564,
    y1: 169.918,
    x2: 155.439,
    y2: 169.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF370D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#E75E3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2053_57321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.548 122.761) rotate(24.928) scale(17.7945 4.01129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2053_57321",
    x1: 188.814,
    y1: 198.827,
    x2: 188.814,
    y2: 196.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A38",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2053_57321",
    x1: 109.51,
    y1: 52.2617,
    x2: 233.893,
    y2: 90.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75E3C",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_57321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 206,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopImgDelete);
export default __webpack_public_path__ + "static/media/top-img-delete.fe72a1e8977ce510c63ac3a849fb6092.svg";
export { ForwardRef as ReactComponent };